<template>
  <div>专题研讨</div>
</template>

<script>
export default {

}
</script>

<style>

</style>